// src/eventing/react-event-source-mapper.ts
import { InputType } from "@nova/types";
var typeMap = {
  dblclick: InputType.mouse,
  keydown: InputType.keyboard,
  keyup: InputType.keyboard,
  keypress: InputType.keyboard,
  mousedown: InputType.mouse,
  mouseenter: InputType.mouse,
  mouseleave: InputType.mouse,
  mousemove: InputType.mouse,
  mouseover: InputType.mouse,
  mouseout: InputType.mouse,
  mouseup: InputType.mouse,
  touchcancel: InputType.touch,
  touchend: InputType.touch,
  touchmove: InputType.touch,
  touchstart: InputType.touch,
  wheel: InputType.mouse
};
var pointerTypeMap = {
  "": InputType.keyboard,
  mouse: InputType.mouse,
  pen: InputType.pen,
  touch: InputType.touch
};
var mapPointerTypeEvents = (pointerType) => {
  const inputType = pointerTypeMap[pointerType];
  return inputType != null ? inputType : InputType.unknown;
};
var mapEventMetadata = (eventWrapper) => {
  const { event, reactEvent } = eventWrapper;
  const inputType = reactEvent.type === "click" ? mapPointerTypeEvents(
    reactEvent.nativeEvent.pointerType
  ) : typeMap[reactEvent.type];
  let timeStamp;
  const uiEvent = reactEvent.nativeEvent;
  if ((uiEvent == null ? void 0 : uiEvent.view) && reactEvent.timeStamp) {
    timeStamp = uiEvent.view.performance.timeOrigin + reactEvent.timeStamp;
  } else {
    timeStamp = Date.now();
  }
  const source = {
    inputType: inputType != null ? inputType : InputType.unknown,
    timeStamp
  };
  const mappedEvent = {
    event,
    source
  };
  return mappedEvent;
};
export {
  mapEventMetadata
};
